import { render, staticRenderFns } from "./priorityProductSource.vue?vue&type=template&id=7ab67627&"
import script from "./priorityProductSource.vue?vue&type=script&lang=js&"
export * from "./priorityProductSource.vue?vue&type=script&lang=js&"
import style0 from "./priorityProductSource.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports